module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/finance/expenditure/expenditure-form/expenditure-form.component.css
// module id = ./src/app/finance/expenditure/expenditure-form/expenditure-form.component.css
// module chunks = main